import React, { useState } from 'react';
import useAppContext from '../../../../hooks/useAppContext';
import { AppContextType } from '../../../../context/AppContext';
import CompanyName from '../../../commonComponents/CompanyName';
import { CompanyNameType } from '../../../../static/types/commonTypes/companyNameType';
import { SlArrowLeft, SlArrowRight } from 'react-icons/sl';
import { FaUpload } from 'react-icons/fa';
import { GoArrowRight } from 'react-icons/go';
import DeceasedCivilStatus from './DeceasedCivilStatus';
import FamilySituation from './FamilySituation';
import WillDetails from './WillDetails';
import NotaryReceivingOppositions from './NotaryReceivingOppositions';
import { formatObjectText } from '../../../../utils/functions/formatObjectText';

interface AnnonceProps {
    txtAnnonce: string;
    updateActiveIndex: (index: number) => void;
    updateTxtAnnonce: (newTxt: string) => void;
    updateDenomination: (newTxt: string) => void;
    societyType: string | string[];
    societeSelected: string;
    updatesocieteSelected: (newTxt: string) => void;

}

const PossessionSending: React.FC<AnnonceProps> = ({
    txtAnnonce,
    updateTxtAnnonce,
    updateActiveIndex,
    updateDenomination,
    societyType,
    updatesocieteSelected
}) => {

    const {

        companyName, setCompanyName,
        companyNameValidity, setCompanyNameValidity,
        companyNameChecked, setCompanyNameChecked,

        individualWithBirthName,
        individualWithBirthNameValidity, setIndividualWithBirthNameChecked,

        dateOfBirth,
        dateOfBirthValidity, setDateOfBirthChecked,

        deathRelatedInfo,
        deathRelatedInfoValidity, setDeathRelatedInfoChecked,

        typeFamilySituationData,

        reducedIndividualPerson,
        reducedIndividualPersonValidity, setReducedIndividualPersonChecked,

        dateOfWill,
        dateOfWillValidity, setDateOfWillChecked,

        dateOfFiling,
        dateOfFilingValidity, setDateOfFilingChecked,

        dateOfReceipt,
        dateOfReceiptValidity, setDateOfReceiptChecked,

        typeHeirsData,

        individual,
        individualValidity, setIndividualChecked,

        notaryData,

        individualNotary,
        individualNotaryValidity, setIndividualNotaryChecked,

    } = useAppContext() as AppContextType
    
    const [activeTab, setActiveTab] = useState<string>('companyName');
    const [visitedTabs, setVisitedTabs] = useState(['companyName']);
    const [ submissive, setSubmissive ] = useState<boolean>( false );
 

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();

        const reducedPersonText = `${reducedIndividualPerson.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${reducedIndividualPerson.lastName} ${reducedIndividualPerson.firstName}`

        const familySituationModel = typeFamilySituationData === 1 
        ? 'pacsé' : typeFamilySituationData === 2 
        ? 'marié' : typeFamilySituationData === 4 
        ? 'veuf' : ''
        
        const familySituationText = (typeFamilySituationData !== 0 && typeFamilySituationData !==3) 
        ? `${familySituationModel} à ${reducedPersonText}` : ''


        const deathRelatedText = deathRelatedInfo.country 
        ? `${deathRelatedInfo.city} (${deathRelatedInfo.country})` 
        : `${deathRelatedInfo.city} (${deathRelatedInfo.postalCode})`

        const pluralWill = (typeHeirsData === 0) ? 'un légataire universel' : 'plusieurs légataires universels'

        const notaryText = `${individual.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${individual.lastName} ${individual.firstName} ${individual.address} ${individual.additionalAddress ? individual.additionalAddress : ''} ${individual.postalCode} ${individual.city}`

        const otherNotaryText = `${individualNotary.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${individualNotary.lastName} ${individualNotary.firstName} ${individualNotary.address} ${individualNotary.additionalAddress ? individualNotary.additionalAddress : ''} ${individualNotary.postalCode} ${individualNotary.city}`

        const notaryOppositionsText = notaryData === 0 ? notaryText : otherNotaryText

        if (validate()) {

            const tempText = `Suivant testament olographe du ${dateOfWill.date}, ${individualWithBirthName.civility === 'Monsieur' ? 'M.' : 'Mme.'} ${individualWithBirthName.lastName} ${individualWithBirthName.firstName} ${individualWithBirthName.firstName} décédé, né ${individualWithBirthName.birthName ? individualWithBirthName.birthName : ''} à ${dateOfBirth.city}, le ${dateOfBirth.dateOfBirth}, demeurant à ${individualWithBirthName.city} ${individualWithBirthName.postalCode} ${individualWithBirthName.address} ${individualWithBirthName.additionalAddress ? ` ${individualWithBirthName.additionalAddress}` : ''} décédé, ${familySituationText}, décédé à ${deathRelatedText}, le ${deathRelatedInfo.dateOfDeath}, a institué ${pluralWill}. Ce testament a fait l'objet d'un dépôt aux termes du procès-verbal d'ouverture et de description de testament reçu par Maître ${notaryText}, le ${dateOfFiling.date}, dont la copie authentique accompagnée d'une copie du testament ont été adressées au Greffe le ${dateOfReceipt.date}. Dans le mois suivant cette réception, l'opposition à l'exercice par le légataire de ses droits pourra être formée par tout intéressé auprès du notaire chargé du règlement de la succession : Maître ${notaryOppositionsText}. En cas d'opposition, le légataire sera soumis à la procédure d'envoi en possession.
            `

            const formattedText = formatObjectText(tempText);
            updateTxtAnnonce(formattedText);
            updateDenomination (companyName.companyName);
            setSubmissive (true);
        }
    };

    const validate = () => {
        // if (!companyNameValidity) {
        //     setActiveTab('companyName')
        // } else if (!(individualWithBirthNameValidity && dateOfBirthValidity && deathRelatedInfoValidity)) {
        //     setActiveTab('deceasedCivilStatus')
        // } else if (!(typeFamilySituationData !== 0 && typeFamilySituationData !== 3)) {
        //     setReducedIndividualPersonChecked(true)
        //     if (!reducedIndividualPersonValidity) {
        //         setActiveTab('familySituation')
        //     }
        // } else if (!(dateOfWillValidity && dateOfFilingValidity && dateOfReceiptValidity && individualValidity)) {
        //     setActiveTab('willDetails')
        // } else if (notaryData !==0) {
        //     setIndividualChecked(true)
        //     if (!individualNotaryValidity) {
        //         setActiveTab('notaryReceivingOppositions')
        //     }
        // }

        let tempIndividualWithBirthNameValidity = individualWithBirthNameValidity && dateOfBirthValidity && deathRelatedInfoValidity;
        let tempFamilySituationValidity = typeFamilySituationData!== 0 && typeFamilySituationData!== 3 ? reducedIndividualPersonValidity : true;
        let tempDateValidity = dateOfWillValidity && dateOfFilingValidity && dateOfReceiptValidity && individualValidity;
        let tempNotaryValidation = notaryData !==0 ? individualNotaryValidity : true
        return companyNameValidity && tempIndividualWithBirthNameValidity && tempFamilySituationValidity && tempDateValidity && tempNotaryValidation;
    };

    const handleNext = () => {
        if (activeTab === "companyName") {
            setCompanyNameChecked(true)
            if (companyNameValidity) {
                switchTab(getNextTab('companyName'));
            }
        } else if (activeTab === "deceasedCivilStatus") {
            setIndividualWithBirthNameChecked(true)
            setDateOfBirthChecked(true)
            setDeathRelatedInfoChecked(true)
            if (individualWithBirthNameValidity && dateOfBirthValidity && deathRelatedInfoValidity) {
                switchTab(getNextTab('deceasedCivilStatus'));
            }
        } else if (activeTab === "familySituation") {
            if (typeFamilySituationData !== 0 && typeFamilySituationData !== 3) {
                setReducedIndividualPersonChecked(true)
                if (reducedIndividualPersonValidity) {
                    switchTab(getNextTab('familySituation'));
                }
            } else switchTab(getNextTab('familySituation'));
        } else if (activeTab === "willDetails") {
            setDateOfWillChecked(true)
            setDateOfFilingChecked(true)
            setDateOfReceiptChecked(true)
            setIndividualChecked(true)
            if (dateOfWillValidity && dateOfFilingValidity && dateOfReceiptValidity && individualValidity) {
                switchTab(getNextTab('willDetails'));
                if (typeHeirsData !== 0) {
                    switchTab(getNextTab('willDetails'));
                } else switchTab(getNextTab('willDetails'));
            } 
        } else if (activeTab === "notaryReceivingOppositions") {
            if (notaryData !== 0) {
                setIndividualNotaryChecked(true)
                if (individualNotaryValidity) {
                    setSubmissive(true)
                }
            } else setSubmissive(true)
        }
    };
    const handlePrevious = () => {
        switchTab(getPreviousTab(activeTab));
        setSubmissive( false )
    };

    const getNextTab = (currentTab: string) => {
        if (currentTab === "companyName") return "deceasedCivilStatus"
        else if (currentTab === "deceasedCivilStatus") return "familySituation"
        else if (currentTab === "familySituation") return "willDetails"
        else if (currentTab === "willDetails") return "notaryReceivingOppositions"
        else return currentTab;
    };

    const getPreviousTab = (currentTab: string) => {
        if (currentTab === "notaryReceivingOppositions") return "willDetails"
        else if (currentTab === "willDetails") return "familySituation"
        else if (currentTab === "familySituation") return "deceasedCivilStatus"
        else if (currentTab === "deceasedCivilStatus") return "companyName"
        else return currentTab;
    };
    const goToSupportPresse = () => {
        updateActiveIndex(2);
    }

    const switchTab = (tab: string) => {
setActiveTab(tab);
    };

    const updateCompanyName = (data: Partial<CompanyNameType>) => setCompanyName ({...companyName, ...data});

    const tabs =[
        {key: 'companyName', label: 'Raison Sociale'},
        {key: 'deceasedCivilStatus', label: 'Etat civil de la personne décédée'},
        {key: 'familySituation', label: 'Situation familiale'},
        {key: 'willDetails', label: 'Informations du testament'},
        {key: 'notaryReceivingOppositions', label: 'Notaire recevant les oppositions'},
    ]

    return (
        <>

                <div className="container my-3">
                <ul className="nav nav-underline">
                    {tabs
                    .filter((t) => t.key === activeTab) 
                    .map((t) => (
                        <li className="nav-item" key={t.key}>
                        <a
                            href={`#${t.key}`}
                            className={`nav-link active`} 
                        >
                            {t.label}
                        </a>
                        </li>
                    ))}
                    </ul>
                </div>
                
            <form onSubmit={handleSubmit}>
                {
                    activeTab === 'companyName' && 
                        <div>
                            <span className='mb-2'>
                                Indiquer la raison sociale de la société ou la dénomination du Cabinet de Notaire annonceur ou l'état civil de la personne concernée par l'annonce, en optionnel vous pouvez ajouter une référence client.
                            </span>
                            <div className="tab-content mt-2">
                                <CompanyName
                                    changeCompanyName={updateCompanyName}
                                    checked = {companyNameChecked}
                                    companyName= {companyName}
                                    onValidationChange={(isValid: boolean) => setCompanyNameValidity (isValid)}
                                    showClientReference= {true}
                                />
                            </div>
                        </div>
                }

                {
                    activeTab === 'deceasedCivilStatus' && 
                        <DeceasedCivilStatus />
                }

                {
                    activeTab === 'familySituation' && 
                        <FamilySituation />
                }

                {
                    activeTab === 'willDetails' && 
                        <WillDetails />
                }

                {
                    activeTab === 'notaryReceivingOppositions' && 
                        <>
                            <NotaryReceivingOppositions 
                                setSubmissive= {setSubmissive}
                            />

                            {
                                submissive &&
                                activeTab === 'notaryReceivingOppositions' && 
                                <div className="mt-4">
                                    <h4>Texte de l'annonce:</h4>
                                    <textarea
                                        className="form-control"
                                        rows={5}
                                        value={ txtAnnonce }
                                        disabled
                                    />
                                </div>
                            }
                        </>
                }

                <div className="button-container">
                    <div className="d-flex gap-2">
                        {
                            activeTab !== 'companyName' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handlePrevious} >
                                    <SlArrowLeft className="icon" style={{ marginRight: '10px',fontSize: '20px' }} />
                                    Modifier mon annonce
                                </button>
                        )}

                        {
                            activeTab === 'notaryReceivingOppositions' && (
                                <button type="submit"
                                    onClick={handleNext}>
                                    Mettre à jour mon annonce
                                    <FaUpload className="icon" style={{ marginLeft: '15px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            activeTab !== 'notaryReceivingOppositions' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={handleNext} >
                                    Suivant
                                    <SlArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )}

                        {
                            submissive && activeTab === 'notaryReceivingOppositions' && (
                                <button color="#F4A261"
                                    className="btn-add"
                                    type="button"
                                    onClick={goToSupportPresse} >
                                    Sélection du support
                                    <GoArrowRight className="icon" style={{ marginLeft: '10px', fontSize: '20px' }} />
                                </button>
                        )} 
                    </div>
                </div>

            </form>
        </>
    );
};

export default PossessionSending;